import {api} from '../../../shared';
import {
  CommunicationMessageDetailModel,
  CommunicationMessagesWithMetaModel,
  CommunicationMessagesFilter,
  CreateCommunicationMessageDTO,
} from '../model';

export const communicationApi = {
  getMessages: async (params: CommunicationMessagesFilter = {}): Promise<CommunicationMessagesWithMetaModel> => {
    const {data} = await api.get<CommunicationMessagesWithMetaModel>('/api/communication/admin/messages', {params});
    return data;
  },

  createMessage: async (messageData: CreateCommunicationMessageDTO): Promise<CommunicationMessageDetailModel> => {
    const {data} = await api.post<CommunicationMessageDetailModel>('/api/communication/admin/messages', messageData);
    return data;
  },

  getMessageById: async (messageId: string): Promise<CommunicationMessageDetailModel> => {
    const {data} = await api.get<CommunicationMessageDetailModel>(`/api/communication/admin/messages/${messageId}`);
    return data;
  },
};
